import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
const initialState = {
    isOpen: false,
    hjelpeskuffTittel: '',
    hjelpeskuffTekst: [],
};
/**
 * Henter hjelpetekst og åpner hjelpeskuffen
 * @param tjenesteNavn Navnet på tjenesten
 * @param hjelpetekstId ID-en til hjelpeteksten
 * @param language Språket som hjelpeteksten skal hentes på
 */
export const fetchAndOpenHjelpeskuff = createAsyncThunk('hjelpeskuff/fetchHelpAndOpen', async ({ tjenesteNavn, hjelpetekstId, language, }, { getState, dispatch, rejectWithValue }) => {
    const response = await dispatch(tjenesteTeksterApi.endpoints.getTjenesteTekster.initiate({
        navn: tjenesteNavn,
        languageCode: language,
    }));
    let hjelpetekst;
    const state = getState();
    if (Array.isArray(hjelpetekstId)) {
        const customHjelpetekst = state.prosesshjelp.customHjelpetekster &&
            state.prosesshjelp.customHjelpetekster[`${tjenesteNavn}.${language}`]?.hjelpetekster?.find(tekst => hjelpetekstId.includes(tekst.id));
        hjelpetekst = customHjelpetekst || response.data?.hjelpetekster?.hjelpetekster.find(tekst => hjelpetekstId.includes(tekst.id));
    }
    else {
        const customHjelpetekst = state.prosesshjelp.customHjelpetekster &&
            state.prosesshjelp.customHjelpetekster[`${tjenesteNavn}.${language}`]?.hjelpetekster?.find(tekst => tekst.id === hjelpetekstId);
        hjelpetekst = customHjelpetekst || response.data?.hjelpetekster?.hjelpetekster?.find(tekst => tekst.id === hjelpetekstId);
    }
    if (!hjelpetekst) {
        return rejectWithValue(`Fant ikke hjelpetekst med id ${hjelpetekstId} for tjeneste ${tjenesteNavn} og språk ${language}`);
    }
    return {
        hjelpeskuffTittel: hjelpetekst.hjelpeskuffTittel,
        hjelpeskuffTekst: hjelpetekst.hjelpeskuffTekst,
    };
});
const hjelpeskuffSlice = createSlice({
    name: 'hjelpeskuff',
    initialState,
    reducers: {
        openHjelpeskuff: (state, action) => {
            const { hjelpeskuffTittel, hjelpeskuffTekst } = action.payload;
            state.status = 'succeeded';
            state.error = undefined;
            state.isOpen = true;
            state.hjelpeskuffTittel = hjelpeskuffTittel;
            state.hjelpeskuffTekst = hjelpeskuffTekst;
        },
        closeHjelpeskuff: state => {
            state.status = 'succeeded';
            state.error = undefined;
            state.isOpen = false;
            state.hjelpeskuffTittel = '';
            state.hjelpeskuffTekst = [];
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAndOpenHjelpeskuff.pending, state => {
            state.status = 'loading';
            state.error = undefined;
            state.isOpen = false;
            state.hjelpeskuffTittel = '';
            state.hjelpeskuffTekst = [];
        })
            .addCase(fetchAndOpenHjelpeskuff.fulfilled, (state, action) => {
            const { hjelpeskuffTittel: title, hjelpeskuffTekst: content } = action.payload;
            state.status = 'succeeded';
            state.error = undefined;
            state.isOpen = true;
            state.hjelpeskuffTittel = title;
            state.hjelpeskuffTekst = content;
        })
            .addCase(fetchAndOpenHjelpeskuff.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
            state.isOpen = true;
            state.hjelpeskuffTittel = 'Feil';
            state.hjelpeskuffTekst = [];
        });
    },
});
export const { openHjelpeskuff, closeHjelpeskuff } = hjelpeskuffSlice.actions;
export default hjelpeskuffSlice.reducer;
export const selectHjelpeskuffState = (state) => state.prosesshjelp.hjelpeskuff;
